import { render } from "./Cohabiting.vue?vue&type=template&id=04d59a62"
import script from "./Cohabiting.vue?vue&type=script&lang=js"
export * from "./Cohabiting.vue?vue&type=script&lang=js"

import exportComponent from "/home/psinclair/git/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__